import { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import SectionTitle from '@features/layout/components/SectionTitle/SectionTitle';
import useIntersect from '@hooks/useIntersect';
import { IAboutCollection } from '@features/productPreview/typescript';
import { WindowType } from '@typescript/index';
import AboutCollectionPlayer from '@features/productPreview/sections/AboutCollection/AboutCollectionVideoPlayer';
import ProductPreviewPageState from '@features/productPreview/mobX/state/ProductPreviewPageState';
import styles from '@features/productPreview/sections/AboutCollection/AboutCollection.styles';
import ErrorBoundary from '@components/errors/ErrorBoundary';
import { VisibleSectionType } from '@features/productPreview/const';
type PropsType = {
  section: IAboutCollection;
  state: ProductPreviewPageState;
  windowType: WindowType;
};
const AboutCollection = ({
  section,
  windowType,
  state
}: PropsType) => {
  const {
    title,
    link,
    buttonText,
    collectionName,
    videos
  } = section;
  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersect(ref, {
    rootMargin: '20%',
    threshold: 1
  });
  const inView = !!entry?.isIntersecting;
  useEffect(() => {
    if (inView) {
      state.setActualVisibleSection(VisibleSectionType.ABOUT_COLLECTION);
    }
  }, [inView, state]);
  return <ErrorBoundary>
      <section sx={styles.section} id={VisibleSectionType.ABOUT_COLLECTION} ref={ref}>
        <div sx={styles.aboutCollectionContainer}>
          <SectionTitle title={title} />
          <div sx={styles.videoContainer}>
            <AboutCollectionPlayer videos={videos} state={state} collectionName={collectionName} link={link} buttonText={buttonText} currentView={windowType} />
          </div>
        </div>
      </section>
    </ErrorBoundary>;
};
export default observer(AboutCollection);